import Vue from 'vue';
import { formatNumeral } from '@/helpers';

export const setFilters = () => {
  Vue.filter('formatNumbers', (value, decimal = 2) => {
    if (value === null) {
      return '-';
    }
    return formatNumeral(value, decimal);
  });

  Vue.filter('formatPrice', (value) => {
    if (value === null) {
      return '-';
    }
    return Math.round(value);
  });
};
